export default __webpack_public_path__ + "static/media/instagram.734a9564.png";